<header class="background-header classic-background"></header>
<section class="main-side-nav" [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default' && themeService.theme != 'boosst' && themeService.theme != 'NWRTheme'}">
	<section class="container admin-dashboard-parent lists-container">
		<section class="template-section-title">
			<div class="breadcrumb-container">
				<span>Admin <i class="fa fas fa-chevron-right"></i></span>
				<app-breadcrumb [pageName]="'Lists'" [isTopLevel]="true"></app-breadcrumb>
			</div>
			<div class="title-container">
				<h1>Lists</h1>
			</div>
		</section>
		<!-- Search -->
		<section class="all-users-list-presentation">
			<section class="search">
				<div class="form-group">
					<label>Show Me</label>
					<select name="users" id="usersSelect">
						<option value="holders">holders</option>
					</select>
				</div>
				<div class="form-group">
					<label>That have</label>
					<select name="users" id="usersSelect">
						<option value="have">have</option>
					</select>
				</div>
				<div class="form-group">
					<label></label>
					<select name="actions" id="usersAction">
						<option value="action">action</option>
					</select>
				</div>
				<div class="form-group">
					<label>In the past</label>
					<select name="timing" id="usersTime">
						<option value="action">Time</option>
					</select>
				</div>
			</section>
			<section class="export">
				<input type="button" class="btn btn-primary export-btn" value="Export" (click)="exportAsXLSX()">
			</section>
		</section>
		<!-- Table data -->
		<section class="all-users-data">
			<div class="table-responsive admin-dashboard-table">
				<table class="table table-bordered table-hover">
					<thead>
					<tr>
						<th scope="col">First Name</th>
						<th scope="col">Last Name</th>
						<th scope="col">Email</th>
						<th scope="col">Last Log In</th>
					</tr>
					</thead>
					<tbody>
					<tr>
						<td></td>
						<td></td>
						<td></td>
						<td></td>
					</tr>
					</tbody>
				</table>
			</div>
		</section>
	</section>
</section>
